import { useTranslations } from "use-intl";

export default function TariffPage() {
  const i18n = useTranslations("tariff");
  return (
    <section className="pt-5">
      <div className="container">
        <h3 className="font-weight-bold mb-5">{i18n("title")}</h3>
        <div>
          <div className="container">
            <h2 className="mb-3">{i18n("title2")}</h2>
            <p>{i18n("content")}</p>
            <p>{i18n("content2")}</p>
            <h3 className="mt-3 mb-3">{i18n("title3")}</h3>
            <p>{i18n("content3")}</p>
          </div>
        </div>
      </div>
    </section>
  );
}
